export type DecSentInitialValues = {
    state?: {
        id?: number | string | null;
        name?: string | null;
    } | null;
    state_id?: number | string | null;
};

interface DecSentStateHandlers {
    setIsDecSent: (value: boolean) => void;
    setDisSubmit: (value: boolean) => void;
    setIsReadOnlyForm: (value: boolean) => void;
}

export const handleDecSentState = ({
    initialValues,
    setIsDecSent,
    setDisSubmit,
    setIsReadOnlyForm,
}: {
    initialValues?: DecSentInitialValues;
} & DecSentStateHandlers): void => {
    const stateId = initialValues?.state?.id ?? initialValues?.state_id;
    const stateName = initialValues?.state?.name ?? initialValues?.state_id;
    const parsedStateId =
        typeof stateId === 'string' ? parseInt(stateId, 10) : stateId;

    const isSentToDec =
        Boolean(parsedStateId) ||
        (typeof stateName === 'string' &&
            (stateName.toLowerCase().includes('відправлено до єв') ||
                stateName.toLowerCase().includes('sent to ev') ||
                stateName.toLowerCase().includes('sent to dec')));

    if (isSentToDec) {
        setIsDecSent(true);
        setDisSubmit(true);
        setIsReadOnlyForm(true);
    }
};
